import { put, call, getContext } from "redux-saga/effects";

import { createInvoice } from "../../Services/ClaimCashless";

export function* createInvoiceSaga(action) {
  const store = yield getContext("store");

  const { payload } = action;
  try {
    const res = yield call(createInvoice, payload);

    yield put({ type: "REQ_CREATE_INVOICE_SUCCESS", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_CREATE_INVOICE_FAILED", errData: e });
  }
}
